import React from 'react'
import './Appsec.css'
import appimg from '../../assets/others/app-img.png'
import app1 from '../../assets/others/11102034.png'
import app2 from '../../assets/others/11102035.png'

const Appsec = () => {
  return (
    <div class="aut-abt-section ws-section p-5 bg-4">
    <div class="container text-center">
                
                <div class="row  txt-lt radius-1 justify-content-around ">
                    <div class="col-lg-6 p-lg-5">
                        <h4 className='app-title'>Your Learning, Your Pace, Your Time</h4>
                        <h5 className='app-tag mb-5'>Download the Takshila VLSI Learning App</h5>

                        <div class="col-lg-7 app-box d-flex">
                            <div class="row g-3">
                                <div class="col-lg-6 ">
                                <img src={app1} alt=''/>
                                </div>
                                <div class="col-lg-6 ms-lg-3">
                                <img src={app2} alt=''/>
                                </div>
                            </div>
                            </div>
                    </div>
                    <div class="col-lg-2 app-img">
                        <img src={appimg } alt=''/>
                    </div>
                </div>
     </div>
 </div>
  )
}

export default Appsec